import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../utils/formValidation/commonConstants';
import { stableSort } from '../../../utils/sortFunctions';
import { uuid } from '../../../utils/stringUtils';
import ResultsTable from '../../table/ResultsTable';

import TimelineRecruitmentEventHistoryTableRow from './TimelineRecruitmentEventHistoryTableRow';

const headCells = [
    { id: 'date', numeric: false, label: 'Date' },
    { id: 'time', numeric: false, label: 'Time' },
    { id: 'username', numeric: false, label: 'User Name' },
    { id: 'from', numeric: false, label: 'From' },
    { id: 'to', numeric: false, label: 'To' }
];

const initialRowMetaData = {
    order: 'desc',
    orderBy: 'date',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const TimelineRecruitmentEventHistoryManagement = ({ eventHistory = [] }) => {
    // LOCAL STATE
    const [rows, setRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);

    // USE EFFECTS
    useEffect(() => {
        if (!eventHistory?.length > 0) return;
        setRows(eventHistory);
    }, []);

    // HELPER FUNCTIONS
    const createRows = () => {
        return stableSort(rows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <TimelineRecruitmentEventHistoryTableRow key={uuid()} row={el} />
        ));
    };

    // RENDER
    return rows.length < 1 ? (
        <div>No timeline recruitment event history found</div>
    ) : (
        <div>
            <ResultsTable
                defaultOrderBy={rowMetaData.orderBy}
                sortOrder={rowMetaData.order}
                defaultRowsPerPage={DEFAULT_TABLE_ROWS_PER_PAGE}
                headCells={headCells}
                loadResults={rows}
                passRowMetaDataUp={setRowMetaData}
                tableRows={createRows()}
                totalResults={rows.length}
            />
        </div>
    );
};

TimelineRecruitmentEventHistoryManagement.propTypes = {
    eventHistory: PropTypes.array
};

export default TimelineRecruitmentEventHistoryManagement;
